var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group with-icon-left" }, [
    _c("div", { staticClass: "input-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.valueProxy,
            expression: "valueProxy",
          },
        ],
        attrs: { id: "input-icon-left", name: "input-icon-left", required: "" },
        domProps: { value: _vm.valueProxy },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.valueProxy = $event.target.value
          },
        },
      }),
      _c("i", {
        staticClass:
          "glyphicon glyphicon-search icon-left input-icon search-icon",
      }),
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "input-icon-left" } },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _c("i", { staticClass: "bar" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }